import React from "react"

export default function Gallery(props) {
    const [imageURL] = React.useState(props.images ? props.images[0] : null)

    return (
        <>
            <img src={imageURL} className={"home-view-individual-image"} alt={"Galerie"} />
        </>
    )
}
